import React from 'react';
import { useSelector } from 'react-redux';

import * as S from 'commons/components/Table/Table.styles';
import { BinTableProps, ProductDetail } from 'commons/types';
import { RowTitleProps } from 'commons/types/listPageData.interface';
import { UserRolesEnum } from 'commons/types/user.roles.enum';
import { TableActionRow, DataTable } from 'pages/dashboard/commons/components';
import { selectUser } from 'redux-stores/features/authSlice';

import BinRowActionBtn from './BinRowActionBtn.component';

const rowTitles: RowTitleProps[] = [
  { title: 'Bin', sortField: 'bin' },
  { title: 'Type' },
  { title: 'SKU Code' },
  { title: 'Commodity' },
];

const Row: React.FC<{
  data: ProductDetail;
  onClickEditQty: (bin: ProductDetail) => void;
  onClickEditInventoryNumber: (bin: ProductDetail) => void;
  index: number;
}> = ({ data, onClickEditQty, onClickEditInventoryNumber, index }) => {
  const user = useSelector(selectUser);
  return (
    <S.TableRow>
      <S.TableColumn
        style={{ width: '20%' }}
        data-testid={`listMasterBinBinNumber${index + 1}`}
      >
        {data.bin}
      </S.TableColumn>
      <S.TableColumn
        style={{ width: '20%', textTransform: 'capitalize' }}
        data-testid={`listMasterBinType${index + 1}`}
      >
        {data.bin_type?.replace('_', ' ') || '-'}
      </S.TableColumn>
      <S.TableColumn
        style={{ width: '25%' }}
        data-testid={`listMasterBinSKU${index + 1}`}
      >
        {data.sku_code}
      </S.TableColumn>
      <S.TableColumn
        style={{ width: '20%' }}
        data-testid={`listMasterBinCommodity${index + 1}`}
      >
        {data.commodity || '-'}
      </S.TableColumn>
      {user.roles.includes(UserRolesEnum.SUPER_ADMIN) && (
        <S.TableColumn
          style={{ width: '15%', textAlign: 'right' }}
          data-testid={`listMasterBinButtons${index + 1}`}
        >
          <BinRowActionBtn
            bin={data}
            onClickEditQty={onClickEditQty}
            onClickEditInventoryNumber={onClickEditInventoryNumber}
          />
        </S.TableColumn>
      )}
    </S.TableRow>
  );
};

const BinTable: React.FC<BinTableProps> = (params): React.ReactNode => {
  const {
    data = [],
    onClickEditQty,
    onClickEditInventoryNumber,
  }: BinTableProps = params;

  return (
    <>
      <TableActionRow />
      <DataTable rowTitles={rowTitles} hideCheckbox>
        <S.TableBody>
          {data.map((item, index) => (
            <Row
              data={item}
              onClickEditQty={onClickEditQty}
              onClickEditInventoryNumber={onClickEditInventoryNumber}
              index={index}
            />
          ))}
        </S.TableBody>
      </DataTable>
      {data.length > 0 && <TableActionRow />}
    </>
  );
};

export default BinTable;
